import { render } from "./PhotoGalleryHOF.vue?vue&type=template&id=be5a6e86&scoped=true"
import script from "./PhotoGalleryHOF.vue?vue&type=script&lang=js"
export * from "./PhotoGalleryHOF.vue?vue&type=script&lang=js"

import "./PhotoGalleryHOF.vue?vue&type=style&index=0&id=be5a6e86&scoped=true&lang=css"

import exportComponent from "C:\\Users\\jgurl\\KontraWebsite\\KontraSports\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-be5a6e86"]])

export default __exports__